import Icon from '../components/Icon.vue'

Icon.register({"train":{"width":1536,"height":1792,"paths":[{"d":"M1088 0q185 0 316.5 93.5t131.5 226.5v896q0 130-125.5 222t-305.5 97l213 202q16 15 8 35t-30 20h-1056q-22 0-30-20t8-35l213-202q-180-5-305.5-97t-125.5-222v-896q0-133 131.5-226.5t316.5-93.5h640zM768 1344q80 0 136-56t56-136-56-136-136-56-136 56-56 136 56 136 136 56zM1344 768v-512h-1152v512h1152z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/train.js
// module id = 1356
// module chunks = 0